import {
  AVAILABILITY_REQUEST,
  AVAILABILITY_SUCCESS,
  AVAILABILITY_FAIL,
  RESERVATION_CREATE_REQUEST,
  RESERVATION_CREATE_SUCCESS,
  RESERVATION_CREATE_FAIL,
  EVENTS_LIST_REQUEST,
  EVENTS_LIST_SUCCESS,
  EVENTS_LIST_FAIL,
  EVENT_DETAILS_REQUEST,
  EVENT_DETAILS_SUCCESS,
  EVENT_DETAILS_FAIL,
  EVENT_RESERVE_REQUEST,
  EVENT_RESERVE_SUCCESS,
  EVENT_RESERVE_FAIL,
  RESERVATION_LOOKUP_REQUEST,
  RESERVATION_LOOKUP_SUCCESS,
  RESERVATION_LOOKUP_FAIL,
  RESERVATION_CANCEL_REQUEST,
  RESERVATION_CANCEL_SUCCESS,
  RESERVATION_CANCEL_FAIL,
} from "../constants/reservationConstants";

export const availabilityReducer = (state = { slots: [] }, action) => {
  switch (action.type) {
    case AVAILABILITY_REQUEST:
      return { loading: true, slots: [] };
    case AVAILABILITY_SUCCESS:
      return { loading: false, slots: action.payload.slots || [] };
    case AVAILABILITY_FAIL:
      return { loading: false, error: action.payload, slots: [] };
    default:
      return state;
  }
};

export const reservationCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case RESERVATION_CREATE_REQUEST:
      return { loading: true };
    case RESERVATION_CREATE_SUCCESS:
      return { loading: false, success: true, reservation: action.payload };
    case RESERVATION_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const eventsListReducer = (state = { events: [] }, action) => {
  switch (action.type) {
    case EVENTS_LIST_REQUEST:
      return { loading: true, events: [] };
    case EVENTS_LIST_SUCCESS:
      return { loading: false, events: action.payload };
    case EVENTS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const eventDetailsReducer = (state = { event: null }, action) => {
  switch (action.type) {
    case EVENT_DETAILS_REQUEST:
      return { loading: true, event: null };
    case EVENT_DETAILS_SUCCESS:
      return { loading: false, event: action.payload };
    case EVENT_DETAILS_FAIL:
      return { loading: false, error: action.payload, event: null };
    default:
      return state;
  }
};

export const eventReserveReducer = (state = {}, action) => {
  switch (action.type) {
    case EVENT_RESERVE_REQUEST:
      return { loading: true };
    case EVENT_RESERVE_SUCCESS:
      return { loading: false, success: true, reservation: action.payload };
    case EVENT_RESERVE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const reservationLookupReducer = (state = { reservation: null }, action) => {
  switch (action.type) {
    case RESERVATION_LOOKUP_REQUEST:
      return { loading: true, reservation: null };
    case RESERVATION_LOOKUP_SUCCESS:
      return { loading: false, reservation: action.payload };
    case RESERVATION_LOOKUP_FAIL:
      return { loading: false, error: action.payload, reservation: null };
    default:
      return state;
  }
};

export const reservationCancelReducer = (state = {}, action) => {
  switch (action.type) {
    case RESERVATION_CANCEL_REQUEST:
      return { loading: true };
    case RESERVATION_CANCEL_SUCCESS:
      return { loading: false, success: true, reservation: action.payload };
    case RESERVATION_CANCEL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
